export const URL_BUSCAR_CLIENTES = "/CxC/WebService/CxcWebService.asmx/BuscarClientes";
export const URL_BUSCAR_TIPOS_CLIENTES = "/CxC/WebService/CxcWebService.asmx/BuscarTiposClientes";
export const URL_BUSCAR_TIPOS_FACTURAS = "/CxC/WebService/CxcWebService.asmx/BuscarTiposFacturas";
export const URL_BUSCAR_TIPOS_FACTURAS_ = "/CxC/WebService/CxcWebService.asmx/BuscarTiposFacturas_";
export const URL_BUSCAR_VENDEDORES = "/Facturacion/WebService/FacturacionWebService.asmx/BuscarVendedores";
export const URL_BUSCAR_TIENDAS = "/Facturacion/WebService/TiendaWebService.asmx/BuscarTiendas";
export const URL_BUSCAR_PERIODOS = "/CxC/WebService/CxcWebService.asmx/BuscarPeriodos";
export const URL_BUSCAR_ANTIGUEDAD = "/CxC/WebService/CxcWebService.asmx/BuscarAntiguedad";
export const URL_BUSCAR_MONEDAS = "/CxC/WebService/CxcWebService.asmx/BuscarMonedas";

export const URL_REPORTE_SALDO_ANTIGUEDAD = "/CxC/WebService/CxcWebService.asmx/SaldoAntiguedadReporte";
export const URL_REPORTE_ESTADO_CUENTA = "/CxC/WebService/CxcWebService.asmx/EstadoCuentaReporte";

export class CxcReporteService {
  static consultar(url, opciones) {
    return new Promise(function (resolve, reject) {
      const where = opciones ? { where: { ...opciones } } : null;
      Citrus.AJAX.getJSON(url, where, function (respuesta) {
        var datos = $.parseJSON(respuesta.d);

        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  }

  static consultarSaldoAntiguedad(where) {
    return this.consultar(URL_REPORTE_SALDO_ANTIGUEDAD, { ...where }).then((res) => {
      return res;
    });
  }

  static consultarEstadoCuenta(where) {
    return this.consultar(URL_REPORTE_ESTADO_CUENTA, { ...where }).then((res) => {
      return res;
    });
  }

  static consultarClientes() {
    return this.consultar(URL_BUSCAR_CLIENTES, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarTiposClientes() {
    return this.consultar(URL_BUSCAR_TIPOS_CLIENTES, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarTiposFacturas() {
    return this.consultar(URL_BUSCAR_TIPOS_FACTURAS).then((res) => res?.Resultados);
  }

  static consultarTiposFacturas_() {
    return this.consultar(URL_BUSCAR_TIPOS_FACTURAS_).then((res) => res?.Resultados);
  }

  static consultarVendedores() {
    return this.consultar(URL_BUSCAR_VENDEDORES, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarTiendas() {
    return this.consultar(URL_BUSCAR_TIENDAS, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }

  static consultarPeriodos() {
    return this.consultar(URL_BUSCAR_PERIODOS).then((res) => res?.Resultados);
  }

  static consultarAntiguedad() {
    return this.consultar(URL_BUSCAR_ANTIGUEDAD).then((res) => res?.Resultados);
  }

  static consultarMonedas() {
    return this.consultar(URL_BUSCAR_MONEDAS, {
      EsPaginable: false,
    }).then((res) => res?.Resultados);
  }
}
